import React from 'react';
import debounce from 'lodash/debounce';
import * as cafeActions from '../../../../redux/cafes/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../../components/loading';
import '../users.scss';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';
import ENUMS from '../../../../enums';

class AddUserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUserInfo: '',
      isSearched: false,
      loaded: false,
      userId: '',
      cafeId: '',
      roleId: '',
      selectedUserId: null,
      isOperator: true,
      tooltipOpen: false
    };
  }

  componentDidMount() {
    if (this.props.editMode) {
      this.props.fetchCafeUserDetails(this.props.userId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.loaded == false &&
      this.props.editMode == true &&
      Object.entries(this.props.cafeUserDetails).length
    ) {
      let { userId, cafeId, roleId } = this.props.cafeUserDetails;

      this.setState({ selectedUserId: userId, cafeId, isOperator: roleId == 3 ? true : false, loaded: true });
    }
  }

  fetchSearchedUser = debounce(
    () => {
      if (this.state.selectedUserInfo.length) {
        this.setState({ isSearched: true });
      } else {
        this.setState({ isSearched: false });
      }
      this.props.fetchSearchedCafeUser(`filter=(textPart~contains~${this.state.selectedUserInfo})`);
    },
    3000,
    {
      maxWidth: 6000,
      trailing: true,
      leading: false
    }
  );

  handleInputChange = event => {
    this.setState({ selectedUserInfo: event.target.value }, () => this.fetchSearchedUser());
  };

  setSelectedUserAfterSearch = user => {
    let { userInfo, id } = user;
    this.setState({ selectedUserInfo: userInfo, selectedUserId: id, isSearched: false });
  };

  setUserToCafe = () => {
    let { cafeId } = this.props;
    let { isOperator, selectedUserId } = this.state;
    let assignUserObject = {
      roleId: isOperator ? 3 : 2,
      userId: selectedUserId,
      cafeId
    };
    if (!this.props.editMode) {
      this.props.assignUserToCafe(assignUserObject).then(() => {
        let { assignError, assignFailed, assignMessage } = this.props;
        if (assignError == false && assignFailed == false && assignMessage == null) {
          AlertAndConfirmation({
            title: '',
            text: locales('titles.userAddedSuccessfully'),
            type: 'success'
          });
          return this.props.closeModal(this.props.cafeId);
        }
      });
    } else {
      this.props.updateCafeUser(this.state.selectedUserId, this.state.isOperator == true ? 3 : 2).then(() => {
        let { updateCafeUserError, updateCafeUserFailed, updateCafeUserMessage } = this.props;
        if (updateCafeUserError == false && updateCafeUserFailed == false && updateCafeUserMessage == null) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          setTimeout(() => {
            return this.props.closeModal(this.props.cafeId);
          }, 3000);
        }
      });
    }
  };

  clearTextBar = () => {
    if (this.state.selectedUserInfo.length)
      this.setState({ selectedUserInfo: '' }, () => {
        this.props.fetchSearchedCafeUser(`filter=(textPart~contains~${this.state.selectedUserInfo})`);
      });
  };

  render() {
    let { selectedUserInfo, isSearched, isOperator } = this.state;
    let {
      searchedUsersList = [],
      loading,
      failed,
      error,
      message,
      assignError,
      assignFailed,
      assignLoading,
      assignMessage,

      cafeUserDetails,
      cafeUserDetailsError,
      cafeUserDetailsFailed,
      cafeUserDetailsLoading,
      cafeUserDetailsMessage,

      updateCafeUserError,
      updateCafeUserFailed,
      updateCafeUserLoading,
      updateCafeUserMessage
    } = this.props;

    return (
      <Spin spinning={false}>
        <Modal size="lg" id="financial-transaction-modal" isOpen={this.props.isOpen}>
          <ModalHeader>
            <div className="row">
              <div className="col-11">
                {locales('titles.assignNewUserToCafe')}{' '}
                {this.props.cafeName.replace(locales('titles.cafe'), '')}
              </div>
              <div className="col-1 text-left">
                <a
                  href="#"
                  className=""
                  onClick={event => {
                    event.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  <i className="fas fa-times"></i>
                </a>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Spin spinning={loading || assignLoading || updateCafeUserLoading || cafeUserDetailsLoading}>
              <form className="col-12">
                {(error || assignError || updateCafeUserError || cafeUserDetailsError) && (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                )}
                {(failed || assignFailed || updateCafeUserFailed || cafeUserDetailsFailed) && (
                  <div className="alert alert-danger">
                    {message || assignMessage || updateCafeUserMessage || cafeUserDetailsMessage}
                  </div>
                )}
                <label className="col-12 d-flex align-items-center" htmlFor="userInput">
                  <span className="col-2">{locales('titles.user')} :</span>
                  {this.props.editMode ? (
                    <div className="border rounded col-6 p-3">{this.props.fullName}</div>
                  ) : (
                    <>
                      <div className="d-flex flex-column col-12">
                        <input
                          id="userInput"
                          value={selectedUserInfo}
                          onChange={this.handleInputChange}
                          type="text"
                          placeholder={locales('titles.nameOrLastNameOrUsername')}
                          className="searchInput form-control col-10"
                          maxLength={ENUMS.MAX_LENGTH.fullName}
                        />
                        <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
                      </div>
                      {isSearched == true && (
                        <div className="border rounded searchedUserResult pointer">
                          {searchedUsersList.length ? (
                            searchedUsersList.map((user, index) => (
                              <div
                                onClick={() => this.setSelectedUserAfterSearch(user)}
                                className={`${
                                  index < searchedUsersList.length - 1 ? 'border-bottom' : ''
                                } p-1`}
                                key={user.id}
                              >
                                {user.userInfo}
                              </div>
                            ))
                          ) : (
                            <div className="d-flex justify-content-center py-2">
                              {locales('alerts.noRecord')}
                            </div>
                          )}
                        </div>
                      )}
                      <i
                        onClick={() => this.clearTextBar()}
                        className="searchDeleteIconPostion pointer fal fa-times-circle text-muted"
                      />
                    </>
                  )}
                </label>
                <div className="col-12 my-3 d-flex justify-content-start">
                  <div className="d-flex col-3">
                    <label htmlFor="isOperator">{locales('labels.operator')}</label>
                    <input
                      type="radio"
                      name="isOperator"
                      id="isOperators"
                      checked={isOperator == true}
                      onChange={() => this.setState({ isOperator: true })}
                    />
                  </div>
                  <div className="d-flex col-3">
                    <label htmlFor="isManager">{locales('labels.manager')}</label>
                    <input
                      type="radio"
                      name="isOperator"
                      id="isManager"
                      checked={isOperator == false}
                      onChange={() => this.setState({ isOperator: false })}
                    />
                  </div>
                </div>
              </form>
            </Spin>
          </ModalBody>
          <ModalFooter>
            <footer className="col-12 d-flex p-0 justify-content-end align-self-center">
              <button className="btn btn-success mx-1 w-25" onClick={() => this.setUserToCafe()}>
                {locales('tables.submit')}
              </button>
            </footer>
          </ModalFooter>
        </Modal>
      </Spin>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchSearchedCafeUser: search => dispatch(cafeActions.fetchSearchedCafeUser(search)),
    assignUserToCafe: assignUserObject => dispatch(cafeActions.assignUserToCafe(assignUserObject)),
    fetchCafeUserDetails: id => dispatch(cafeActions.fetchCafeUserDetails(id)),
    updateCafeUser: (userId, roleId) => dispatch(cafeActions.updateCafeUser(userId, roleId))
  };
};
const mapStateToProps = state => {
  return {
    loading: state.cafesReducer.searchedUsersLoading,
    error: state.cafesReducer.searchedUsersError,
    message: state.cafesReducer.searchedUsersMessage,
    failed: state.cafesReducer.searchedUsersFailed,
    searchedUsers: state.cafesReducer.searchedUsers,
    searchedUsersList: state.cafesReducer.searchedUsersList,

    assignLoading: state.cafesReducer.assignUserToCafeLoading,
    assignError: state.cafesReducer.assignUserToCafeError,
    assignMessage: state.cafesReducer.assignUserToCafeMessage,
    assignFailed: state.cafesReducer.assignUserToCafeFailed,

    cafeUserDetailsLoading: state.cafesReducer.cafeUserDetailsLoading,
    cafeUserDetailsMessage: state.cafesReducer.cafeUserDetailsMessage,
    cafeUserDetailsError: state.cafesReducer.cafeUserDetailsError,
    cafeUserDetailsFailed: state.cafesReducer.cafeUserDetailsFailed,
    cafeUserDetails: state.cafesReducer.cafeUserDetails,

    updateCafeUserLoading: state.cafesReducer.updateCafeUserLoading,
    updateCafeUserMessage: state.cafesReducer.updateCafeUserMessage,
    updateCafeUserError: state.cafesReducer.updateCafeUserError,
    updateCafeUserFailed: state.cafesReducer.updateCafeUserFailed
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddUserModal));
